import React from "react";
import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

const CardPage = () => (
  <Box>
    <Typography
      variant="subtitle1"
      sx={{ textAlign: "center", color: grey[600] }}
    >
      Nothing To Display
    </Typography>
  </Box>
);

export default CardPage;
